<template>
  <v-app :data-guide="guideNo + 1"
         :style="{ '--system-bar-height': `${notchTop}px`, '--system-bottom-height': `${notchBottom}px` }">
    <v-system-bar v-if="notchTop" app fixed color="transparent" :height="notchTop" dark />
    <!-- 도서관 검색 캐싱 추가 > 뒤로 가기시 정보 유지 요청 -->
    <keep-alive :include='["LibraryDetails", "LibrarySearch", "LibrarySearchResultNew"]'>
      <!-- route fullPath 에서 path 로 변경 fullPath 사용하면 캐싱된 컴포넌트 6개까지 생성됨  -->
      <router-view ref="content" @libraryHeart="setHeart" @isDestination="isDestination"
                   @insertMemberBadgePoss="insertMemberBadgePoss" @deleteMemberBadgePoss="deleteMemberBadgePoss"
                   @insertMemberCoin="insertMemberCoin"
                   :key="$route.path"
      />
    </keep-alive>
    <!-- Snackbars -->
    <Snackbars ref="toast" @snackbarClick="snackbarClick"/>
    <!-- 뱃지 모달-->
    <ModalBadge />
    <!-- 코인 -->
    <ModalCoin />
  </v-app>
</template>

<script>
import store from './store'
import {mixinAuth, mixinRemote, mixinReward} from '@/mixins'
import Util from '@/utils/utils'
import VueCookies from 'vue-cookies'
import Snackbars from '@/components/layout/Snackbars.vue'
import ModalBadge from "@/components/layout/modal/ModalBadge"
import ModalCoin from "@/components/layout/modal/ModalCoin";

export default {
  name: 'App',
  components: {
    Snackbars,
    ModalBadge,
    ModalCoin
  },
  mixins: [mixinAuth, mixinRemote, mixinReward],
  data: () => ({
    hearton: true,
    isDestinationSheet: true,
    timerInterval: null,
    expireTime: null,
    timeSecond: null
  }),
  computed: {
    isAppBar() {
      return this.$route.meta.isHideHeader;
    },
    apptitle() {
      return this.$route.meta.headerTitle;
    },
    isHeart: {
      get: function () {
        return this.hearton
      },
      set: function (val) {
        this.hearton = val
      }
    },
    notchTop() {
      return this.$root.notchTop
    },
    notchBottom() {
      return this.$root.notchBottom
    }
  },
  watch: {
    // API 비동기 호출로 인해
    // userKey(nV) {
    //   if (!nV) return
    //   if (this.timerInterval) clearInterval(this.timerInterval)
    //   this.timerInterval = setInterval(async () => {
    //     this.expireTime = this.getSessionExpire()
    //   }, 1000)
    //
    //   if (!store.getters.denyCode && !store.getters.globalErrorStatus) {
    //     store.dispatch('getUserGuideImageNumber') // 실행안됨 메인에서 호출
    //   } else {
    //     let target = store.getters.globalErrorStatus ? '/com-error' : '/exp-error'
    //     this.$router.replace(target)
    //   }
    // },
    timeSecond(v1, v2) {
      if (v2) {
        if (!v1 || v1 <= 0) {
          // 토큰 제거는 공통으로 해줘야함. 안그러면 메인페이지 진입 무한 루프
          VueCookies.remove('dms-user-token')
          Util.Common.removeLocalStorage('expireSessionTime')
          clearInterval(this.timerInterval)
          // 자동 로그인
          if (VueCookies.isKey('hm-rmal')) {
            window.location.href = '/user'
          } else {
            store.commit('setDenyCode', '9401')
            this.$router.replace('/exp-error')
          }
        } /*else if (v1 === 300) { // 300초 되면 수동로그인은 갱신여부 물어봄 -> 일단 해당건은 사용하지 않음
          // this.$confirm('5분 후에 자동 로그아웃이 됩니다. 로그인을 연장하시겠습니까?', {
          //   persistent: false,
          //   showClose: true,
          //   actions: {
          //     false: {text: '취소'},
          //     true: {text: '확인'}
          //   }
          // }).then(value => {
          //   if (value) {
          //     VueCookies.remove('dms-user-token')
          //     Util.Common.removeLocalStorage('expireSessionTime')
          //     store.dispatch('getToken')
          //   }
          // })
        }*/
      }
    },
    clientCd(v1, v2) {
      if (v1 !== v2) {
        // TODO 테마 구분을 위한 임시 위치 전체 적용을 위해서는 위치 변경 필요
        this.$root.setThemes(this.clientCd)
      }
    }
  },
  created() {
    // TODO 테마 구분을 위한 임시 위치 전체 적용을 위해서는 위치 변경 필요
    this.$root.setThemes(this.clientCd)
    // this.getNotch()

    window.callbackNotch = (top, bottom) => {
      this.$root.notchTop = top
      this.$root.notchBottom = bottom
    }
    // 확인용
    // this.$root.notchTop = 36
    // this.$root.notchBottom = 20
  },
  mounted() {
    store.dispatch('getAnifitProUrl')

    if (this.userKey) {
      if (this.timerInterval) clearInterval(this.timerInterval)
      this.timerInterval = setInterval(async () => {
        this.expireTime = this.getSessionExpire()
      }, 1000)
      if (!store.getters.denyCode && !store.getters.globalErrorStatus) {
        store.dispatch('getUserGuideImageNumber') // 실행안됨 메인에서 호출
      } else {
        let target = store.getters.globalErrorStatus ? '/com-error' : '/exp-error'
        this.$router.replace(target)
      }
    }
    this.appHeight();
    window.addEventListener('resize', this.appHeight);
  },
  methods: {
    expireSessionTime () {
      return Util.Date.toFormatDate(new Date(Util.Common.getLocalStorage('expireSessionTime') * 1), 'YYYYMMDDHHmmss')
    },
    today () {
      return Util.Date.getToday('YYYYMMDDHHmmss')
    },
    getSessionExpire () {
      let diffNow = Util.Date.diffNow(this.expireSessionTime(), this.today())

      this.timeSecond = diffNow
      if (diffNow === 0) {
        clearInterval(this.timerInterval) // 새로 세션값 가져오기 전 까지는 세션체크 안하도록
      }

      let time = diffNow / 60
      let minutes = parseInt(time)
      let second = Math.round((time - minutes) * 60)

      return (minutes.toString().padStart(2, '0') + ':' + second.toString().padStart(2, '0'))
    },
    isDestination: function (is) {
      this.isDestinationSheet = is;
    },
    setHeart: function (is) {
      this.hearton = is;
    },
    /* 여행지도 배경 바꾸기 */
    destinationSheetStatus() {
      this.$refs.content.destinationSheetStatus(true);
    },
    /* 도서관 검색 */
    librarySearch() {
      // this.$refs.content.librarySearch();
    },
    libraryLike: function () {

      const fnLike = this.$refs.content.libraryLike;
      if (fnLike !== undefined && fnLike !== null) {
        const likePostNo = fnLike();

        if (likePostNo !== undefined && likePostNo !== null) {
          store.dispatch('setLibraryLike', this.$_payload({'libNo': likePostNo}, {}))
            .then(res => {
              if (res.success) {
                if (res.data == 'delete') {
                  this.hearton = true;
                  this.deleteMemberBadgePoss(4, 1) //badgeNo,badgeDtlNo
                } else {
                  this.hearton = false;
                  this.insertMemberBadgePoss(4, 4) //badgeNo,badgeDtlNo
                }
              } else {
                // console.log(res.msg)
              }
            })
            .catch(error => {
              console.error(error)
            })
            .finally(() => {
            })
        }
      }
    },
    /* 채팅 메뉴 */
    chattingMenu() {
      this.$refs.content.chattingMenu();
    },
    /* toast click */
    snackbarClick(goUrl) {
      let goUrlS = goUrl
      if (goUrlS == 'travelToastOpen') {
        /* 사후검사 */
        this.$refs.content.examinationOpen(1);
      }
      this.$refs.toast.toast = false;
    },
    /* 높이값 vh 계산 */
    appHeight() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', vh + 'px');
    },
    // getNotch () {
    //   const userAgent = navigator.userAgent.toLowerCase();
    //   if (userAgent.indexOf('android') >= 0) {
    //     console.log('android')
    //   } else {
    //     window.webkit.messageHandlers.getIOSNotch.postMessage('1234')
    //   }
    // }
  }
};
</script>
